import _Object$assign from 'babel-runtime/core-js/object/assign';
import _extends from 'babel-runtime/helpers/extends';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import _intersection from 'lodash/intersection';
import _take from 'lodash/take';
import _dropRight from 'lodash/dropRight';
import _isNil from 'lodash/isNil';
import _last from 'lodash/last';
import _noop from 'lodash/noop';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import MediaConsumer from '@sitebase/media-context/es/MediaConsumer';

import DrawerContext from './DrawerContext';
import { getAllowedAttributes } from '../../props-filters';
import './Drawer.scss';

var ANIMATABLE_CLASS = 'sb-header-drawer__content--animatable';

var Drawer = function (_PureComponent) {
  _inherits(Drawer, _PureComponent);

  function Drawer(props, context) {
    _classCallCheck(this, Drawer);

    var _this = _possibleConstructorReturn(this, (Drawer.__proto__ || _Object$getPrototypeOf(Drawer)).call(this, props, context));

    _this.animationInProgress = false;

    _this.handleTransitionEndOnHeightSet = function () {
      _this.node.classList.remove(ANIMATABLE_CLASS);
      _this.node.removeEventListener('transitionend', _this.handleTransitionEndOnHeightSet);
      _this.animationInProgress = false;
    };

    _this.handleTransitionEndOnHeightReset = function () {
      _this.node.classList.remove(ANIMATABLE_CLASS);
      _this.node.removeEventListener('transitionend', _this.handleTransitionEndOnHeightReset);
      _this.node.style.removeProperty('height');
      _this.animationInProgress = false;
    };

    _this.performAnimation = function (height) {
      _this.node.classList.add(ANIMATABLE_CLASS);
      _this.node.style.setProperty('height', height + 'px');
    };

    _this.animateHeight = function (height) {
      if (_this.animationInProgress) {
        _this.node.removeEventListener('transitionend', _this.handleTransitionEndOnHeightSet);
        _this.node.removeEventListener('transitionend', _this.handleTransitionEndOnHeightReset);
      }

      _this.animationInProgress = true;

      var _this$node$getBoundin = _this.node.getBoundingClientRect(),
          firstHeight = _this$node$getBoundin.height;

      if (!height) {
        _this.node.style.removeProperty('height');

        var _this$node$getBoundin2 = _this.node.getBoundingClientRect(),
            lastHeight = _this$node$getBoundin2.height;

        _this.node.style.setProperty('height', firstHeight + 'px');

        requestAnimationFrame(function () {
          return _this.performAnimation(lastHeight);
        });
        _this.node.addEventListener('transitionend', _this.handleTransitionEndOnHeightReset);
      } else {
        _this.node.style.setProperty('height', firstHeight + 'px');

        requestAnimationFrame(function () {
          return _this.performAnimation(height);
        });
        _this.node.addEventListener('transitionend', _this.handleTransitionEndOnHeightSet);
      }
    };

    _this.isRootActive = function () {
      return !_this.state.activePath.length;
    };

    _this.isActive = function (itemId) {
      return _this.state.activePath.includes(itemId);
    };

    _this.isLevelBelow = function (itemId) {
      return _this.state.activePath.indexOf(itemId) !== _this.state.activePath.length - 1;
    };

    _this.selectPrevious = function () {
      var activePath = _this.state.activePath;

      _this.toggleActive(activePath);
    };

    _this.updateActive = function (itemPath, hasSubLevel) {
      var activePath = _this.state.activePath;

      var newActivePath = null;

      // closing levels - clicked item within active path
      if (activePath.join().includes(itemPath.join())) {
        newActivePath = _dropRight(itemPath);
      }
      // opening levels - clicked item originates from active path or totally separated
      else if (hasSubLevel) {
          newActivePath = itemPath;
        }
        // closing levels - clicked item separated from active path
        else {
            newActivePath = _intersection(activePath, itemPath);
          }

      _this.setState({
        activePath: newActivePath
      });
      return newActivePath;
    };

    _this.toggleActive = function (itemPath, hasSubLevel) {
      var onChange = _this.props.onChange;

      var newActivePath = _this.updateActive(itemPath, hasSubLevel);
      var id = _last(newActivePath);
      onChange(id);
    };

    _this.goUpTo = function (itemPath) {
      var activePath = _this.state.activePath;

      if (activePath.join().includes(itemPath.join())) {
        var pathToGo = _take(activePath, itemPath.length + 1);
        _this.toggleActive(pathToGo);
      }
    };

    _this.goToRoot = function (event) {
      if (event.target === event.currentTarget || event.target === _this.node) {
        event.stopPropagation();
        var activePath = _this.state.activePath;

        var pathToGo = _take(activePath, 1);
        _this.toggleActive(pathToGo);
      }
    };

    _this.storeRef = function (node) {
      _this.node = node;

      if (node) {
        requestAnimationFrame(function () {
          _this.minHeight.unshift(node.scrollHeight);
        });
      }
    };

    _this.adjustHeight = function (value) {
      if (_isNil(value)) _this.minHeight.pop();else _this.minHeight.push(value);

      var height = _this.isRootActive() ? 0 : Math.max.apply(Math, _toConsumableArray(_this.minHeight));
      _this.animateHeight(height);
    };

    _this.drawerUtils = {
      toggleActive: _this.toggleActive,
      goUpTo: _this.goUpTo,
      adjustHeight: _this.adjustHeight,
      isActive: _this.isActive,
      isLevelBelow: _this.isLevelBelow
    };

    _this.renderDrawer = function (_ref) {
      var device = _ref.device;

      var _this$props = _this.props,
          className = _this$props.className,
          children = _this$props.children,
          restProps = _objectWithoutProperties(_this$props, ['className', 'children']);

      var activePath = _this.state.activePath;

      var below = Boolean(activePath.length);

      var classNames = cx({
        'sb-header-drawer__content': true,
        'sb-header-drawer__content--below': below
      }, 'sb-header-drawer__content--' + device, className);

      return React.createElement(
        'nav',
        _extends({ className: 'sb-header-drawer' }, getAllowedAttributes(restProps)),
        React.createElement(
          'ul',
          { ref: _this.storeRef, className: classNames, onClick: below ? _this.goToRoot : null },
          children
        )
      );
    };

    _this.state = {
      activePath: []
    };
    _this.minHeight = [];
    _this.node = null;
    return _this;
  }

  /**
   * Animates node height property using FLIP technique.
   * If height is not set property will be removed and calculated one will be used.
   */


  _createClass(Drawer, [{
    key: 'render',
    value: function render() {
      // SBKS-2599
      // Variable copyOfDrawerUtils is just a dumb copy of drawerUtils. It
      // exists in order to fix the drawer functionality in react 16. Providing
      // new instance of drawerUtils to the DrawerContext triggers rerender of
      // consumer. Without that on react 16 sublevel isn't visible.
      var copyOfDrawerUtils = _Object$assign({}, this.drawerUtils);
      return React.createElement(
        DrawerContext.Provider,
        { value: copyOfDrawerUtils },
        React.createElement(
          MediaConsumer,
          null,
          this.renderDrawer
        )
      );
    }
  }]);

  return Drawer;
}(PureComponent);

Drawer.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func,
  children: PropTypes.node
};
Drawer.defaultProps = {
  onChange: _noop
};
export default Drawer;
//# sourceMappingURL=Drawer.js.map